import {weather_sheet} from "./sprites.js";
import {getRandomArbitrary, getRandomInt} from "../../util/color";
import {Container, Sprite} from "pixi.js";


function makeTextureSprite(texture_name) {
    return weather_sheet.textures[texture_name];
}


export function makeHailTextureSprite() {
    return weather_sheet.textures["snow.png"];
}

export function makeSnowFlake() {
    let flake;
    switch(getRandomInt(1, 4)){
        case 1:
            flake = new Sprite(makeTextureSprite("snow_blur4.png"));
            flake.alpha = getRandomArbitrary(0.7, 1);
            break;
        case 2:
            flake = new Sprite(makeTextureSprite("snow_blur8.png"));
            flake.alpha = getRandomArbitrary(0.5, 0.7);
            break;
        case 3:
            flake = new Sprite(makeTextureSprite("snow_blur12.png"));
            flake.alpha = getRandomArbitrary(0.3, 0.5);
            break;
    }
    return flake;
}

export function makeRainTextureSprite() {
    let rain = new Sprite(makeTextureSprite("rain_normal.png"));
    if (Math.random() > 0.2) {
        rain.alpha = getRandomArbitrary(0.7, 0.9);
    } else {
        rain.alpha = getRandomArbitrary(0.3, 0.4);
    }
    return rain;
}


export function makeRainTexture(renderer, is_severe) {

    let lineLength = is_severe ? 20 : 14;
    let strokeColor = is_severe ? 0x7d91a1 : 0x86a3f9;

    // Draw the line
    let gr = new Graphics();
    gr.lineStyle({width: 2, color: strokeColor, alpha: 0.9, cap: "round"});
    // Draw line
    gr.moveTo(0, 0);
    gr.lineTo(0, lineLength);
    return renderer.generateTexture(gr);
}


export function makeRainTextureDroplet(renderer, is_severe) {

    let color = is_severe ? 0xffffff : 0xffffff;

    // Draw the line
    let drop = new Graphics()
        .beginFill(color, 1)
        .drawCircle(0, 0, 10);
    let cone = new Graphics()
        .beginFill(color, 1)
        .lineTo(0, -25)
        .arc(0, -25, 25, 1.15, 1.97)
        .lineTo(0, -25);
    let holder = new Container();
    holder.addChild(drop);
    holder.addChild(cone);

    return renderer.generateTexture(holder);
}